import { PurchaseTraceCodeDialogComponent } from '../purchase-trace-code-dialog/purchase-trace-code-dialog.component';
import { BaseComponentService } from 'src/app/services/_app/base-component.service';
import { PurchasesTracesService } from 'src/app/services/purchases-traces.service';
import { ClientStorageService } from 'src/app/services/client-storage.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiError } from 'src/app/models/api/api-error.model';
import { Component, Inject, inject } from '@angular/core';
import { AppTools } from 'src/app/utils/tools';

@Component({
  selector: 'app-purchases-traces-dialog',
  templateUrl: './purchases-traces-dialog.component.html',
})
export class PurchasesTracesDialogComponent {
  private _clientStorageService = inject(ClientStorageService);
  private _baseComponentService = inject(BaseComponentService);
  private _purchasesTracesService: PurchasesTracesService = inject(
    PurchasesTracesService
  );

  protected categoriesOptions =
    this._purchasesTracesService.categoriesLabelsOptions;
  protected purchaseTraceId?: string = undefined;
  protected isPosting: boolean = false;
  protected error?: ApiError;

  protected formGroup: FormGroup = new FormGroup({
    dea_id: new FormControl({ value: '', disabled: true }),
    headquarter: new FormControl(
      this._clientStorageService.getHeadquarterString().toUpperCase(),
      Validators.required
    ),
    category: new FormControl(null, Validators.required),
    custom_category: new FormControl(null),
    vendor: new FormControl(null, Validators.required),
    amount: new FormControl(null, Validators.required),
    description: new FormControl(),
    file: new FormControl(null),
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _dialogRef: MatDialogRef<PurchasesTracesDialogComponent>
  ) {
    this._purchasesTracesService.getPurchaseTraceCategories().subscribe();
    this.purchaseTraceId = this.data?.purchaseTraceId || this.data?.id;
    if (this.purchaseTraceId) this._getPurchaseTraceDetails();
  }

  private async _getPurchaseTraceDetails() {
    this.formGroup.disable();
    this._purchasesTracesService
      .getPurchaseTraceDetails(this.purchaseTraceId)
      .subscribe({
        next: (response) => this.formGroup.patchValue({ ...response.data }),
        error: (error) => {
          this._baseComponentService.showErrorDialog({ error });
          this._dialogRef.close(false);
        },
      })
      .add(() => this.formGroup.enable());
  }

  protected onFileChange(event: any) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.formGroup?.patchValue({ file: file });
    }
  }

  protected onConfirm() {
    this.isPosting = true;
    this.error = undefined;
    if (this.formGroup.valid === false) {
      this.error = new ApiError({
        message: 'Compila tutti i campi non contrassegnati come opzionali.',
      });
      this.isPosting = false;
      return;
    }
    const formValue = this.formGroup.value;
    const data = AppTools.removeNullAndReplaceWithUndefined({ ...formValue });
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      if (data[key] !== null && data[key] !== undefined) {
        formData.append(key, data[key]);
      }
    });
    const file: any = this.formGroup.get('file')?.value;
    if (file) {
      if (formData.has('file')) formData.delete('file');
      formData.append(
        'file',
        file,
        file.name || new Date().toISOString().slice(0, 10)
      );
    }
    if (this.purchaseTraceId) {
      this._purchasesTracesService
        .patchPurchaseTrace(this.purchaseTraceId, formData)
        .subscribe({
          next: () => this._dialogRef.close(true),
          error: (error: ApiError) => {
            this._baseComponentService.showErrorDialog({ error });
          },
        })
        .add(() => (this.isPosting = false));
    } else {
      this._purchasesTracesService.postPurchaseTrace(formData).subscribe({
        next: (response) => {
          this._baseComponentService.dialog
            .open(PurchaseTraceCodeDialogComponent, {
              autoFocus: false,
              restoreFocus: false,
              maxWidth: '680px',
              data: { dea_id: response.data?.dea_id },
            })
            .afterClosed()
            .subscribe(() => this._dialogRef.close(false));
        },
        error: (error: ApiError) => {
          this._baseComponentService.showErrorDialog({ error });
        },
      });
    }
  }

  protected onDismiss(): void {
    this._dialogRef.close(false);
  }
}
